import { render, staticRenderFns } from "./VerticalScrollLayout.vue?vue&type=template&id=40279224&scoped=true&"
import script from "./VerticalScrollLayout.vue?vue&type=script&lang=js&"
export * from "./VerticalScrollLayout.vue?vue&type=script&lang=js&"
import style0 from "./VerticalScrollLayout.vue?vue&type=style&index=0&id=40279224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40279224",
  null
  
)

export default component.exports